export default {
  id: { "ui:widget": "hidden" },
  startTime: { "ui:widget": "select" },
  endTime: { "ui:widget": "select" },
};
